import { useState, useEffect } from "react";
import axios from "axios";
import { useParams} from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper } from "../../modules/helpers";
import Swal from "sweetalert2";
import { member, consult, consult_by_memberId, order_by_memberId, file_upload, evaluate_by_memberId, order } from '../../components/apipath';



function AdmMemberEdit() {
    const {mem_id} = useParams();
    const { token } = useAuth();
    const [memberData, setMemberData] = useState();
    const [orderData, setOrderData] = useState({});
    const [errors, setErrors] = useState({});
    const [orderMemoEdits, setOrderMemoEdits] = useState({});
    const [addonOrders, setAddonOrders] = useState([]);
    const [addonMemoEdits, setAddonMemoEdits] = useState({});

    const memberStatus = [
        { label: '在職者', value: 'incumbent' },
        { label: '在學生', value: 'student' },
        { label: '全職考生', value: 'candidates' },
        { label: '待業中', value: 'unemployed' }
    ];
    const industryStatus = [
        { label: '在學中', value: 'student' },
        { label: '會計師事務所', value: 'account' },
        { label: '投資銀行業', value: 'investment' },
        { label: '其他金融業', value: 'financial' },
        { label: '製造業', value: 'manufacturing' },
        { label: '電子業', value: 'electronics' },
        { label: '其他', value: 'other' },
    ];
    const userType = ['請選擇', 'CPA', 'CMA'];

    const [consultData, setConsultData] = useState({
        consult_id: null, 
        bachelor_program_type: '',
        bachelor_acct_courses: '',
        bachelor_biz_courses: '',
        bachelor_total_credits: '',
        master_program_type: '',
        master_acct_courses: '',
        master_biz_courses: '',
        master_total_credits: '',
        eligible_types: '',
        evaluator_name: '',
        evaluated_at: null,
        interviewer_name: '',
        interview_date: '', 
        evaluation_note: '',
        consult_note: ''
    });
    
    const [evalList, setEvalList] = useState([]);

    const fetchEvaluateData = async (id) => {
    try {
        const res = await axios.get(`${evaluate_by_memberId}${id}`, { headers:{ token }});
        const rows = res.data?.data || [];
        setEvalList(Array.isArray(rows) ? rows : [rows]);
    } catch (e) {
        console.error(e);
    }
    };

    useEffect(() => {
    fetchEvaluateData(mem_id);
    }, [mem_id]);

    const [origMemberData, setOrigMemberData] = useState(null);
    const getSSNLabel = (value) => {
    switch (value) {
        case 0: case "0": return "沒有";
        case 1: case "1": return "有";
        default: return "未填寫";
    }
    };

    const getOccupationLabel = (value) => {
    switch (value) {
        case 1: case "1": return "在學生";
        case 2: case "2": return "在職者";
        case 3: case "3": return "待業中";
        case 4: case "4": return "服役中";
        default: return "未填寫";
    }
    };

    const getExperienceLabel = (value) => {
    switch (value) {
        case 1: case "1": return "否";
        case 2: case "2": return "1年以內";
        case 3: case "3": return "1-3年";
        case 4: case "4": return "3-5年";
        case 5: case "5": return "5年以上";
        default: return "未填寫";
    }
    };

    const industryMap = {
    accounting_firm: "會計事務所",
    law_firm: "法律事務所",
    banking: "銀行相關",
    financial_consulting: "金融投顧",
    manufacturing: "製造相關",
    ecommerce: "電子商務",
    biotechnology: "生物科技",
    software_engineering: "資訊工程",
    consulting_services: "顧問服務",
    other: "其他"
    };
    const getIndustryLabel = (value) => industryMap[value] || "未填寫";

    const purposeMap = {
    cpa_exam: "抵免台灣會計師考試",
    foreign_company: "進外商公司",
    career_competition: "增加職場競爭力",
    promotion: "升遷、加薪籌碼",
    practice_demand: "執業需求",
    study_abroad: "計劃一年內出國留學",
    immigration: "計畫移民",
    };
    const getPurposeLabels = (purposes) => {
    if (!purposes) return "—";
    const values = Array.isArray(purposes) ? purposes : String(purposes).split(',');
    return values.map((value) => {
        if (String(value).startsWith("other:")) return `其他：${String(value).slice(6)}`;
        return purposeMap[value] || "未知目的";
    }).join("、");
    };

    // 小工具：欄位組件（Bootstrap 3）
    const Field = ({ label, value, wide = false, children }) => (
    <div className={wide ? "col-xs-12" : "col-xs-12 col-sm-6 col-md-4"}>
        <div className="clearfix" style={{marginBottom: 6}}>
        <div className="text-muted" style={{fontSize: 12}}>{label}</div>
        <div style={{whiteSpace: 'pre-wrap', wordBreak:'break-word'}}>
            {children || (value !== undefined && value !== null && value !== '' ? value : '—')}
        </div>
        </div>
    </div>
    );

    // 轉日期
    const fmtDate = (d) => (d ? dateHelper(d, 'date') : '—');


    const validateForm = () => {
    const v = memberData || {};
    const e = {};

    if (v.chinese_name && !/^[\u4e00-\u9fa5]{2,}$/.test(v.chinese_name)) e.chinese_name = "僅限中文且不可包含符號";
    if (v.first_name && v.first_name.length > 200) e.first_name = "英文名字過長";
    if (v.last_name && v.last_name.length > 200) e.last_name = "英文姓氏過長";
    if (v.phone_num && !/^\d+$/.test(v.phone_num)) e.phone_num = "電話號碼僅可輸入數字";
    if (v.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) e.email = "請輸入有效 Email";
    if (v.id_num && v.id_num.length > 20) e.id_num = "身分證字號過長";
    if (v.address && v.address.length > 255) e.address = "地址過長";
    if (v.school && v.school.length > 255) e.school = "學校名稱過長";

    setErrors(e);
    return Object.keys(e).length === 0;
    };

        
    const fetchData = async (id) => {
    try{
        const response = await axios.get(`${member}${id}`, { headers:{ token }});
        const row = response.data[0];
        setMemberData(row);
        setOrigMemberData(row);     // ← 作為 diff 的基準
    } catch (error) {
        console.error(error);
    }
    };

    const fetchOrderData = async (id) => {
        try{
        const response = await axios.get(`${order_by_memberId}${id}`, {headers:{token: token}});
        setOrderData(response.data.data); 
        } catch(error) {
        console.error(error);
        }
    }

    const fetchAddonOrders = async (id) => {
    try {
        const res = await axios.get(`${order}addorder/${id}`, {
        headers: { token }
        });
        setAddonOrders(res.data?.data || []);
    } catch (error) {
        console.error(error);
    }
    };
    
    useEffect(() => { fetchAddonOrders(mem_id); }, [mem_id]); 

    const toDateInput = v => (v ? String(v).slice(0, 10) : '');

    // 正規化一筆資料（包含日期格式）
    const normalizeConsult = row => ({
        ...row,
        evaluated_at: toDateInput(row?.evaluated_at),
    });

    // 讀取：進頁面帶出唯一一筆
    const fetchConsultData = async (id) => {
        const res = await axios.get(`${consult_by_memberId}${id}`, { headers:{ token }});
        const row = res.data?.data || null;
        if (row) {
        setConsultData(prev => ({
            ...prev,
            ...row,
            evaluated_at: row.evaluated_at ? String(row.evaluated_at).slice(0,10) : '',
        }));
        }
    };
    
    useEffect(() => { fetchConsultData(mem_id); }, [mem_id]);


    const buildPatchPayload = (orig, curr) => {
    const diff = { mem_id: curr.mem_id || mem_id }; // 一定帶 mem_id
    const READONLY = new Set(['createtime', 'account']); // 不要更新的欄位

    Object.keys(curr || {}).forEach(k => {
        if (READONLY.has(k)) return;
        const a = (orig || {})[k];
        const b = curr[k];
        const same = JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
        if (!same) diff[k] = b;
    });
    return diff;
    };

    // 儲存：永遠呼叫 upsert（沒資料會新增；有資料會更新）
    const handleConsultSave = async () => {
        const payload = { ...consultData, mem_id };
        const res = await axios.post(`${consult}`, payload, { headers:{ token }});
        if (res.data?.status === 200) {
        Swal.fire({ icon:'success', title:'已儲存諮詢資料' });
        fetchConsultData(mem_id);
        }
    };
    
    const handleConsultChange = (e) => {
        const { name, value } = e.target;
        setConsultData(prev => ({ ...prev, [name]: value }));
    };

    useEffect(()=>{ fetchConsultData(mem_id); }, []);
    useEffect(()=>{ fetchData(mem_id) }, []);
    useEffect(()=>{ fetchOrderData(mem_id) }, []);

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
        setMemberData({
            ...memberData,
            [name]: switchHelper(checked),
        });
        } else {
        setMemberData({
            ...memberData,
            [name]: value,
        });
        }
    }

    const handleSave = async () => {
    const ok = validateForm();
    if (!ok) {
        const r = await Swal.fire({
        icon: "warning",
        title: "有格式提醒",
        text: "有些欄位格式不完全正確，仍要儲存目前已填內容嗎？",
        showCancelButton: true,
        confirmButtonText: "仍要儲存"
        });
        if (!r.isConfirmed) return;
    }

    const payload = buildPatchPayload(origMemberData, memberData);
    if (Object.keys(payload).length <= 1) { // 只剩 mem_id
        Swal.fire({ icon: "info", title: "沒有任何變更" });
        return;
    }

    try {
        const res = await axios.put(`${member}`, payload, { headers: { token }});
        if (res.data.status === 200) {
        Swal.fire({ icon: "success", title: "更新成功" });
        setErrors({});
        setOrigMemberData(memberData); // 更新基準
        } else {
        Swal.fire({ icon: "error", title: "儲存失敗", text: res.data.msg || "請稍後再試。" });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "系統錯誤", text: error?.response?.data?.msg || "儲存失敗，請稍後再試。" });
    }
    };

    const saveOrderMemo = async (order_id, memo) => {
  try {
    const trimmed = (memo ?? '').trim();
    const res = await axios.put(
      `${order}memo/${order_id}`,
      { memo: trimmed },
      { headers: { token } }
    );

    if (res.data?.status === 200) {
      Swal.fire({ icon: 'success', title: '已更新訂單備註' });
      // 同步更新前端的 orderData
      setOrderData(prev =>
        Array.isArray(prev)
          ? prev.map(o => o.order_id === order_id ? { ...o, memo: trimmed } : o)
          : prev
      );
    } else {
      Swal.fire({ icon: 'error', title: '更新失敗', text: res.data?.msg || '請稍後再試' });
    }
  } catch (e) {
    Swal.fire({ icon: 'error', title: '系統錯誤', text: e?.response?.data?.msg || e.message });
  }
};
const saveAddonMemo = async (add_id, memo) => {
  try {
    const trimmed = (memo ?? '').trim();
    // 路徑你可以依照後端實際命名調整
    const res = await axios.put(
      `${order}addorder/memo/${add_id}`,
      { memo: trimmed },
      { headers: { token } }
    );

    if (res.data?.status === 200) {
      Swal.fire({ icon: 'success', title: '已更新加購備註' });
      // 更新前端的 addonOrders
      setAddonOrders(prev =>
        Array.isArray(prev)
          ? prev.map(o => o.add_id === add_id ? { ...o, memo: trimmed } : o)
          : prev
      );
    } else {
      Swal.fire({ icon: 'error', title: '更新失敗', text: res.data?.msg || '請稍後再試' });
    }
  } catch (e) {
    Swal.fire({ icon: 'error', title: '系統錯誤', text: e?.response?.data?.msg || e.message });
  }
};


    return (
        <>
        <div className="container" style={{marginTop:"50px"}}>
            <div className="row g-2">
            <div className="col-12 text-center">
                <h3 className="fw-bold">學生資料</h3>
            </div>
            <div className="col-12">
                <hr></hr>
            </div>
            { memberData && (
                <>
                <div className="col-xl-2 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    {SwitchBox('account_status', memberData.account_status, handleInputChange, "帳戶狀態")}
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                    <div className="input-group input-group-sm">
                    {SwitchBox('mem_status', memberData.mem_status, handleInputChange, "正式學員")}
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    {SwitchBox('pass', memberData.pass, handleInputChange, "已通過")}
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    {SwitchBox('refund', memberData.refund, handleInputChange, "已退費")}
                    </div>
                </div>

                <div className="col-12">
                    <hr/>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">創建日期</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="date" 
                        name="createtime" 
                        defaultValue={dateHelper(memberData.createtime, 'date')} 
                        required 
                        readOnly
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">到期日期</span>
                    <input 
                        className={`form-control form-control-sm ${errors.active_date ? "is-invalid" : ""}`} 
                        type="date" 
                        name="active_date" 
                        defaultValue={dateHelper(memberData.active_date, 'date')} 
                        onChange={handleInputChange}
                    />
                    {errors.active_date && <div className="invalid-feedback">{errors.active_date}</div>}
                    </div>
                </div>    

                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">數位點數</span>
                    <input
                        className={`form-control form-control-sm ${errors.total_points ? "is-invalid" : ""}`} 
                        type="number"
                        name="total_points"
                        value={(memberData.total_points)}
                        onChange={handleInputChange}
                    />
                    {errors.total_points && <div className="invalid-feedback">{errors.total_points}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">
                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>學員狀態
                    </span>
                    <select
                        className="form-select form-select-sm"
                        onChange={handleInputChange}
                        name="status"
                        value={memberData.status}
                        required
                    >
                        <option value="">請選擇</option>
                        {memberStatus.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                    </select>
                    </div>
                </div>                       

                <div className="col-12">
                    <hr/>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">
                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>中文姓名
                    </span>
                    <input 
                        className={`form-control form-control-sm ${errors.chinese_name ? "is-invalid" : ""}`} 
                        type="text" 
                        name="chinese_name" 
                        defaultValue={memberData.chinese_name} 
                        maxLength={24}
                        required 
                        onChange={handleInputChange} 
                    />
                    {errors.chinese_name && <div className="invalid-feedback">{errors.chinese_name}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">帳號</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="account" 
                        defaultValue={memberData.account} 
                        required 
                        readOnly
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">
                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>密碼
                    </span>
                    <input 
                        className="form-control form-control-sm" 
                        type="password" 
                        name="password" 
                        defaultValue={memberData.password} 
                        required 
                        onChange={handleInputChange} 
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">
                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>科目
                    </span>
                    <select 
                        className="form-select form-select-sm" 
                        name="user_type" 
                        value={memberData.user_type} 
                        onChange={handleInputChange}
                    >
                        {userType.map((item, index)=>(
                        <option key={index} value={index===0 ? '' : item}>{item}</option>
                        ))}
                    </select>
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text"><i className="fa-regular fa-star fa-fw text-danger me-1"/>英文名字</span>
                    <input 
                        className={`form-control form-control-sm ${errors.first_name ? "is-invalid" : ""}`}
                        type="text" 
                        name="first_name" 
                        maxLength={200}
                        defaultValue={memberData.first_name} 
                        onChange={handleInputChange}
                    />
                    {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text"><i className="fa-regular fa-star fa-fw text-danger me-1"/>英文姓氏</span>
                    <input 
                        className={`form-control form-control-sm ${errors.last_name ? "is-invalid" : ""}`}
                        type="text" 
                        name="last_name" 
                        maxLength={200}
                        defaultValue={memberData.last_name} 
                        onChange={handleInputChange}
                    />
                    {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">證件號碼</span>
                    <input 
                        className={`form-control form-control-sm ${errors.id_num ? "is-invalid" : ""}`} 
                        type="text" 
                        name="id_num" 
                        maxLength={20}
                        defaultValue={memberData.id_num} 
                        onChange={handleInputChange}
                    />
                    {errors.id_num && <div className="invalid-feedback">{errors.id_num}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text"><i className="fa-regular fa-star fa-fw text-danger me-1"></i>連絡電話</span>
                    <input 
                        className={`form-control form-control-sm ${errors.phone_num ? "is-invalid" : ""}`} 
                        type="text" 
                        name="phone_num" 
                        maxLength={40}
                        defaultValue={memberData.phone_num} 
                        onChange={handleInputChange}
                        required
                    />
                    {errors.phone_num && <div className="invalid-feedback">{errors.phone_num}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text"><i className="fa-regular fa-star fa-fw text-danger me-1"></i>Email</span>
                    <input 
                        className={`form-control form-control-sm ${errors.email ? "is-invalid" : ""}`} 
                        type="text" 
                        name="email" 
                        maxLength={255}
                        defaultValue={memberData.email} 
                        onChange={handleInputChange}
                        required
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                </div>

                <div className="col-xl-6 col-md-6 col-12">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">地址</span>
                    <input 
                        className={`form-control form-control-sm ${errors.address ? "is-invalid" : ""}`} 
                        type="text" 
                        name="address" 
                        maxLength={255}
                        defaultValue={memberData.address} 
                        onChange={handleInputChange}
                    />
                    {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                    </div>
                </div>
                                
                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">學校</span>
                    <input 
                        className={`form-control form-control-sm ${errors.school ? "is-invalid" : ""}`}
                        type="text" 
                        name="school" 
                        maxLength={255}
                        defaultValue={memberData.school} 
                        onChange={handleInputChange}
                    />
                    {errors.school && <div className="invalid-feedback">{errors.school}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">科系/專業</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="major" 
                        maxLength={255}
                        defaultValue={memberData.major} 
                        onChange={handleInputChange}
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">年級</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="grade" 
                        maxLength={255}
                        defaultValue={memberData.grade} 
                        onChange={handleInputChange}
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">產業</span>
                    <select
                        className="form-select form-select-sm"
                        onChange={handleInputChange}
                        name="industry"
                        value={memberData.industry}
                        required
                    >
                        <option value="">請選擇</option>
                        {industryStatus.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                    </select>
                    </div>
                </div>
                                
                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">年資</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="workyear" 
                        maxLength={255}
                        defaultValue={memberData.workyear} 
                        onChange={handleInputChange}
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">職稱</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="jobtitle" 
                        maxLength={255}
                        defaultValue={memberData.jobtitle} 
                        onChange={handleInputChange}
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">職涯規劃</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="reason" 
                        maxLength={255}
                        defaultValue={memberData.reason} 
                        onChange={handleInputChange}
                    />
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">公司</span>
                    <input 
                        className={`form-control form-control-sm ${errors.company_name ? "is-invalid" : ""}`}
                        type="text" 
                        name="company_name" 
                        maxLength={255}
                        defaultValue={memberData.company_name} 
                        onChange={handleInputChange}
                    />
                    {errors.company_name && <div className="invalid-feedback">{errors.company_name}</div>}
                    </div>
                </div>

                <div className="col-xl-3 col-md-3 col-6">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">如何得知Becker</span>
                    <input 
                        className="form-control form-control-sm" 
                        type="text" 
                        name="info_way" 
                        maxLength={255}
                        defaultValue={memberData.info_way} 
                        onChange={handleInputChange}
                    />
                    </div>
                    {errors.info_way && <div className="invalid-feedback">{errors.info_way}</div>}
                </div>

                <div className="col-12"></div>
                                
                <div className="col-xl-11 col-12">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">備註</span>
                    <textarea
                        className={`form-control form-control-sm ${errors.comment ? "is-invalid" : ""}`}
                        type="text" 
                        name="comment" 
                        rows={10}
                        defaultValue={memberData.comment} 
                        onChange={handleInputChange}
                    ></textarea>
                    {errors.comment && <div className="invalid-feedback">{errors.comment}</div>}
                    </div>
                </div>

                <div className="col-xl-1 col-12">
                    <div className="m-2 text-center">
                    <a href={`${file_upload}member/${mem_id}/mResume`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">履歷</a>
                    <a href={`${file_upload}member/${mem_id}/mTranscript`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">成績單</a>
                    <a href={`${file_upload}member/${mem_id}/mInterview`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">諮詢紀錄</a>
                    <a href={`${file_upload}member/${mem_id}/mApplication`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">報考文件</a>
                    <a href={`${file_upload}member/${mem_id}/mAcademic`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">學歷認證</a>
                    <button className="btn btn-sm w-100 btn-danger m-1" onClick={handleSave}>儲存</button>
                    </div>
                </div>
                </>
            )}
            </div>

            <hr/>

            {/* ===== 購買紀錄（分四表：BASIC/CPE/BRIDGE/UT） ===== */}
            <div className="row g-2 table-responsive mt-5 mb-3">
            <div className="col-12">
                <h5 className="fw-bold">購買紀錄</h5>
            </div>

            {(() => {
            // 將單筆/多筆都正規化
            const rows = Array.isArray(orderData) ? orderData : (orderData ? [orderData] : []);

            const formatDate = (d) => {
                if (!d) return '—';
                try {
                const dt = new Date(d);
                if (isNaN(dt.getTime())) return String(d).split('T')[0] || String(d);
                return dt.toISOString().split('T')[0];
                } catch { return String(d); }
            };
            const formatMoney = (n) => (isNaN(Number(n)) ? '—' : Number(n).toLocaleString());
            const formatDateTime = (d) => {
                if (!d) return '—';
                try {
                    const dt = new Date(d);
                    if (isNaN(dt.getTime())) {
                    // 若是 '2025-01-01 10:30:00' 之類，就直接切掉秒數
                    return String(d).replace('T', ' ').slice(0, 16);
                    }
                    // 2025-01-01 10:30
                    return dt.toISOString().slice(0, 10) + ' ' + dt.toTimeString().slice(0, 5);
                } catch {
                    return String(d);
                }
                };

            const parseBridgeCourses = (val) => {
                try {
                if (Array.isArray(val)) return val.map(String);
                if (typeof val === 'string') {
                    const t = val.trim();
                    if (!t) return [];
                    if (t.startsWith('[')) return JSON.parse(t).map(String);
                    return t.split(',').map(s => s.trim()).filter(Boolean);
                }
                } catch {}
                return [];
            };

            



            // UT 原因顯示：將 code→中文
            const reasonLabel = (code) => {
                switch (code) {
                case 'prep_cpa':  return '預習美國 CPA';
                case 'prep_ea':   return '預習美國 EA';
                case 'work_fast': return '工作需用，速懂全盤';
                case 'interest':  return '自學充實興趣';
                default:          return code;
                }
            };
            const parseReasons = (val) => {
                if (Array.isArray(val)) return val.map(String);
                if (typeof val === 'string') {
                return val.split(',').map(s => s.trim()).filter(Boolean);
                }
                return [];
            };
            const reasonsToText = (val) => {
                const arr = parseReasons(val);
                return arr.length ? arr.map(reasonLabel).join('、') : '—';
            };

            // 依 product.parent_id 嚴格分類（1=CPA, 2=CMA, 3=EA, 4=CPE, 5=BRIDGE, 6=UT）
            const PARENT = { CPA: 1, CMA: 2, EA: 3, CPE: 4, BRIDGE: 5, UT: 6 };

            const getType = (o) => {
                const hasPid = o && o.product_parent_id !== undefined && o.product_parent_id !== null;
                if (hasPid) {
                const pid = Number(o.product_parent_id);
                if (!Number.isNaN(pid)) {
                    if (pid === PARENT.CPA)    return 'CPA';
                    if (pid === PARENT.CMA)    return 'CMA';
                    if (pid === PARENT.EA)     return 'EA';
                    if (pid === PARENT.CPE)    return 'CPE';
                    if (pid === PARENT.BRIDGE) return 'BRIDGE';
                    if (pid === PARENT.UT)     return 'UT';
                }
                }
                // 備援：用產品名稱判斷（避免後端漏帶 parent_id）
                const name = (o?.product || o?.product_name || '').toUpperCase();
                if (name.includes(' CPE') || name.startsWith('CPE')) return 'CPE';
                if (name.includes('BRIDGE') || name.includes('學分班')) return 'BRIDGE';
                if (name.includes('UT') || name.includes('美稅')) return 'UT';
                if (name.includes('CPA')) return 'CPA';
                if (name.includes('CMA')) return 'CMA';
                if (name.includes('EA'))  return 'EA';

                // 依欄位特徵判斷（再備援）
                const hasText = (v) => typeof v === 'string' && v.trim() !== '' && v.trim() !== '-' && v.trim() !== '—';
                const looksLikeEmail = (s) => typeof s === 'string' && s.includes('@');
                const looksLikeDate  = (s) => !!Date.parse(s);

                if (hasText(o?.ut_reasons) || looksLikeDate(o?.ut_activation_date)) return 'UT';
                if (hasText(o?.bridge_birthdate) || hasText(o?.bridge_courses))      return 'BRIDGE';
                if (looksLikeEmail(o?.cpe_email) || looksLikeDate(o?.cpe_activation_date) || hasText(o?.cpe_company_name)) {
                return 'CPE';
                }
                // 實在判不出就歸類到「CPA」(或改成 '未知' 也可以)
                return 'CPA';
            };

            // 分類
            const cpa    = rows.filter(o => getType(o) === 'CPA');
            const cma    = rows.filter(o => getType(o) === 'CMA');
            const ea     = rows.filter(o => getType(o) === 'EA');
            const cpe    = rows.filter(o => getType(o) === 'CPE');
            const bridge = rows.filter(o => getType(o) === 'BRIDGE');
            const ut     = rows.filter(o => getType(o) === 'UT');

            return (
                <>
                {/* CPA 訂單 */}
                <div className="col-12 mt-3">
                    <h6 className="fw-bold">CPA 訂單</h6>
                    <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                        <th scope="col">購買編號</th>
                        <th scope="col">產品</th>
                        <th scope="col">加購書籍</th>
                        <th scope="col">折扣</th>
                        <th scope="col">總金額</th>
                        <th scope="col">下單日</th>
                        <th scope="col">備註</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cpa.length ? cpa.map((o) => (
                        <tr key={`cpa-${o.order_id}`}>
                            <td>{o.order_id}</td>
                            <td>{o.product || o.product_name}</td>
                            <td>{o.book || '—'}</td>
                            <td>{o.discount || '—'}</td>
                            <td>{formatMoney(o.total_price)}</td>
                            <td>{formatDate(o.order_date)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                            memoKey={o.order_id}
                            value={o.memo || ""}
                            edits={orderMemoEdits}
                            setEdits={setOrderMemoEdits}
                            onSave={(memo) => saveOrderMemo(o.order_id, memo)}
                            />

                            </td>

                        </tr>
                        )) : (
                        <tr><td colSpan="7" className="text-muted text-center">目前沒有 CPA 訂單</td></tr>
                        )}
                    </tbody>
                    </table>
                </div>

                {/* CMA 訂單 */}
                <div className="col-12 mt-4">
                    <h6 className="fw-bold">CMA 訂單</h6>
                    <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                        <th scope="col">購買編號</th>
                        <th scope="col">產品</th>
                        <th scope="col">加購書籍</th>
                        <th scope="col">折扣</th>
                        <th scope="col">總金額</th>
                        <th scope="col">下單日</th>
                        <th scope="col">備註</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cma.length ? cma.map((o) => (
                        <tr key={`cma-${o.order_id}`}>
                            <td>{o.order_id}</td>
                            <td>{o.product || o.product_name}</td>
                            <td>{o.book || '—'}</td>
                            <td>{o.discount || '—'}</td>
                            <td>{formatMoney(o.total_price)}</td>
                            <td>{formatDate(o.order_date)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                            memoKey={o.order_id}
                            value={o.memo || ""}
                            edits={orderMemoEdits}
                            setEdits={setOrderMemoEdits}
                            onSave={(memo) => saveOrderMemo(o.order_id, memo)}
                            />
                            </td>

                        </tr>
                        )) : (
                        <tr><td colSpan="7" className="text-muted text-center">目前沒有 CMA 訂單</td></tr>
                        )}
                    </tbody>
                    </table>
                </div>

                {/* （可選）EA 訂單：如果你也想分開顯示就保留，否則可整段刪除 */}
                <div className="col-12 mt-4">
                    <h6 className="fw-bold">EA 訂單</h6>
                    <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                        <th scope="col">購買編號</th>
                        <th scope="col">產品</th>
                        <th scope="col">加購書籍</th>
                        <th scope="col">折扣</th>
                        <th scope="col">總金額</th>
                        <th scope="col">下單日</th>
                        <th scope="col">備註</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ea.length ? ea.map((o) => (
                        <tr key={`ea-${o.order_id}`}>
                            <td>{o.order_id}</td>
                            <td>{o.product || o.product_name}</td>
                            <td>{o.book || '—'}</td>
                            <td>{o.discount || '—'}</td>
                            <td>{formatMoney(o.total_price)}</td>
                            <td>{formatDate(o.order_date)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                            memoKey={o.order_id}
                            value={o.memo || ""}
                            edits={orderMemoEdits}
                            setEdits={setOrderMemoEdits}
                            onSave={(memo) => saveOrderMemo(o.order_id, memo)}
                            />
                            </td>

                        </tr>
                        )) : (
                        <tr><td colSpan="7" className="text-muted text-center">目前沒有 EA 訂單</td></tr>
                        )}
                    </tbody>
                    </table>
                </div>

                {/* CPE 訂單（原樣保留） */}
                <div className="col-12 mt-4">
                    <h6 className="fw-bold">CPE 訂單</h6>
                    <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                        <th scope="col">購買編號</th>
                        <th scope="col">產品</th>
                        <th scope="col">CPE 信箱</th>
                        <th scope="col">CPE 啟用日</th>
                        <th scope="col">公司名稱</th>
                        <th scope="col">總金額</th>
                        <th scope="col">下單日</th>
                        <th scope="col">備註</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cpe.length ? cpe.map((o) => (
                        <tr key={`cpe-${o.order_id}`}>
                            <td>{o.order_id}</td>
                            <td>{o.product || o.product_name}</td>
                            <td>{o.cpe_email || '—'}</td>
                            <td>{formatDate(o.cpe_activation_date)}</td>
                            <td>{o.cpe_company_name || '—'}</td>
                            <td>{formatMoney(o.total_price)}</td>
                            <td>{formatDate(o.order_date || o.created_at)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                                orderId={o.order_id}
                                value={o.memo || ""}                  // 來源值（後端 SELECT 要有 o.memo）
                                edits={orderMemoEdits}
                                setEdits={setOrderMemoEdits}
                                onSave={saveOrderMemo}                // 你現有的儲存函式
                            />
                            </td>
                        </tr>
                        )) : (
                        <tr><td colSpan="8" className="text-muted text-center">目前沒有 CPE 訂單</td></tr>
                        )}
                    </tbody>
                    </table>
                </div>

                {/* 學分班訂單（原樣保留） */}
                <div className="col-12 mt-4">
                    <h6 className="fw-bold">學分班訂單</h6>
                    <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                        <th scope="col">購買編號</th>
                        <th scope="col">產品</th>
                        <th scope="col">出生年月日</th>
                        <th scope="col">選課</th>
                        <th scope="col">總金額</th>
                        <th scope="col">下單日</th>
                        <th scope="col">備註</th>
                        
                        </tr>
                    </thead>
                    <tbody>
                        {bridge.length ? bridge.map((o) => {
                        const ids = parseBridgeCourses(o.bridge_courses);
                        const courseText = o.csu_courses_text || o.csu_courses || (ids.length ? `${ids.length} 門課（ID: ${ids.join(', ')}）` : '—');
                        return (
                            <tr key={`br-${o.order_id}`}>
                            <td>{o.order_id}</td>
                            <td>{o.product || o.product_name}</td>
                            <td>{formatDate(o.bridge_birthdate)}</td>
                            <td>{courseText}</td>
                            <td>{formatMoney(o.total_price)}</td>
                            <td>{formatDate(o.order_date || o.created_at)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                            memoKey={o.order_id}
                            value={o.memo || ""}
                            edits={orderMemoEdits}
                            setEdits={setOrderMemoEdits}
                            onSave={(memo) => saveOrderMemo(o.order_id, memo)}
                            />
                            </td>
                            </tr>
                        );
                        }) : (
                        <tr><td colSpan="7" className="text-muted text-center">目前沒有學分班訂單</td></tr>
                        )}
                    </tbody>
                    </table>
                </div>

                {/* 美稅（UT）訂單（原樣保留） */}
                <div className="col-12 mt-4">
                    <h6 className="fw-bold">美稅（UT）訂單</h6>
                    <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                        <th scope="col">購買編號</th>
                        <th scope="col">產品</th>
                        <th scope="col">啟用日</th>
                        <th scope="col">選購原因</th>
                        <th scope="col">總金額</th>
                        <th scope="col">下單日</th>
                        <th scope="col">備註</th>

                        </tr>
                    </thead>
                    <tbody>
                        {ut.length ? ut.map((o) => (
                        <tr key={`ut-${o.order_id}`}>
                            <td>{o.order_id}</td>
                            <td>{o.product || o.product_name}</td>
                            <td>{formatDate(o.ut_activation_date)}</td>
                            <td>{reasonsToText(o.ut_reasons)}</td>
                            <td>{formatMoney(o.total_price)}</td>
                            <td>{formatDate(o.order_date || o.created_at)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                            memoKey={o.order_id}
                            value={o.memo || ""}
                            edits={orderMemoEdits}
                            setEdits={setOrderMemoEdits}
                            onSave={(memo) => saveOrderMemo(o.order_id, memo)}
                            />
                            </td>
                        </tr>
                        )) : (
                        <tr><td colSpan="7" className="text-muted text-center">目前沒有美稅訂單</td></tr>
                        )}
                    </tbody>
                    </table>
                </div>
                {/* ===== 新增：加購紀錄 ===== */}
                <div className="col-12 mt-4">
                <h6 className="fw-bold">加購紀錄</h6>
                <table className="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th scope="col">加購編號</th>        {/* add_id */}
                        <th scope="col">加購項目</th>        {/* add_on_items */}
                        <th scope="col">總金額</th>          {/* total_amount */}
                        <th scope="col">匯款時間</th>        {/* remit_time */}
                        <th scope="col">匯款人</th>          {/* remit_name */}
                        <th scope="col">建立時間</th>
                        <th scope="col">備註</th>
                    </tr>
                    </thead>
                    <tbody>
                    {addonOrders && addonOrders.length ? (
                        addonOrders.map(o => (
                        <tr key={`addon-${o.add_id}`}>
                            <td>{o.add_id}</td>
                            <td>{o.add_on_items_names || '—'}</td>
                            <td>{formatMoney(o.total_amount)}</td>
                            <td>{formatDateTime(o.remit_time)}</td>
                            <td>{o.remit_name || '—'}</td>
                            <td>{formatDateTime(o.created_at)}</td>
                            <td style={{ minWidth: 280 }}>
                            <MemoCell
                            memoKey={o.add_id}                     // 這裡用加購自己的主鍵
                            value={o.memo || ""}                  // addon_orders.memo，要在 SELECT 時取出
                            edits={addonMemoEdits}                // 用另一組 state 管理
                            setEdits={setAddonMemoEdits}
                            onSave={(memo) => saveAddonMemo(o.add_id, memo)}   // 打加購的 API
                            />
                            </td>
                        </tr>
                        ))
                    ) : (
                        <tr>
                        <td colSpan="7" className="text-muted text-center">
                            目前沒有加購紀錄
                        </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                </div>
                </>
            );
            })()}
            <hr/>
            </div>
                <div className="row g-2 mt-4">
                <div className="col-xs-12">
                    <h5 className="fw-bold">評估紀錄</h5>
                </div>

                {evalList && evalList.length ? evalList.map((r, idx) => (
                    <div key={`eval-card-${idx}`} className="col-xs-12">
                    <div className="panel panel-default">
                        <div className="panel-heading clearfix">
                        <div className="pull-left">
                            <strong>{r.student_name || memberData?.chinese_name || '學生'}</strong>
                            <span className="text-muted" style={{marginLeft: 8}}>
                            （填表：{fmtDate(r.create_time || r.createtime || r.created_at)}）
                            </span>
                        </div>
                        <div className="pull-right">
                            <span className={
                            r.status === '完成' ? 'label label-success' :
                            r.status === '取消' ? 'label label-default' :
                            'label label-info'
                            }>
                            {r.status || '審核中'}
                            </span>
                        </div>
                        </div>

                        <div className="panel-body">
                        <div className="row">

                            <Field label="地區" value={r.area} />
                            <Field label="目前身份" value={getOccupationLabel(r.occupation)} />
                            <Field label="職業類別" value={getIndustryLabel(r.industry)} />
                            <Field label="財務工作經驗" value={getExperienceLabel(r.exp)} />
                            <Field label="SSN" value={getSSNLabel(r.ssn)} />
                            <Field label="緣由" value={r.reason} />

                            <Field label="報考目的" value={getPurposeLabels(r.purpose)} wide />

                            <Field label="成績單檔案" wide>
                            {(r.file || r.file_url)
                                ? (
                                <a
                                    className="btn btn-default btn-xs"
                                    href={`${file_upload}member/${r.mem_id}/mTranscript`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="在新分頁檢視（右鍵可另存）"
                                >
                                    檢視文件
                                </a>
                                )
                                : <span className="text-muted">—</span>
                            }
                            </Field>

                            <Field label="備註" value={r.memo || r.note} wide />
                        </div>
                        </div>
                    </div>
                    </div>
                )) : (
                    <div className="col-xs-12">
                    <div className="text-muted text-center">尚無評估資料</div>
                    </div>
                )}
                </div>
            <hr/>

            {/* ===== 諮詢（資格評估） ===== */}
            <div className="row g-2 mt-4 mb-5">
            <div className="col-12">
                <h5 className="fw-bold">諮詢（資格評估）</h5>
            </div>

            {/* 學士學位 */}
            <div className="col-xl-3 col-md-4 col-12">
                <div className="input-group input-group-sm">
                <span className="input-group-text">學士學制</span>
                <input
                    className="form-control form-control-sm"
                    name="bachelor_program_type"
                    value={consultData.bachelor_program_type}
                    onChange={handleConsultChange}
                    placeholder="五專插大 / 四年制 / 三年制"
                />
                </div>
            </div>
            <div className="col-xl-9 col-12">
                <div className="input-group input-group-sm">
                <span className="input-group-text">學士-會計相關</span>
                <input
                    className="form-control form-control-sm"
                    name="bachelor_acct_courses"
                    value={consultData.bachelor_acct_courses}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-9 col-12">
                <div className="input-group input-group-sm mt-1">
                <span className="input-group-text">學士-商業相關</span>
                <input
                    className="form-control form-control-sm"
                    name="bachelor_biz_courses"
                    value={consultData.bachelor_biz_courses}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-3 col-md-4 col-6">
                <div className="input-group input-group-sm mt-1">
                <span className="input-group-text">大學總學分</span>
                <input
                    className="form-control form-control-sm"
                    name="bachelor_total_credits"
                    value={consultData.bachelor_total_credits}
                    onChange={handleConsultChange}
                />
                </div>
            </div>

            {/* 碩士學位 */}
            <div className="col-xl-3 col-md-4 col-12">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">碩士學制</span>
                <input
                    className="form-control form-control-sm"
                    name="master_program_type"
                    value={consultData.master_program_type}
                    onChange={handleConsultChange}
                    placeholder="一年制 / 兩年制"
                />
                </div>
            </div>
            <div className="col-xl-9 col-12">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">碩士-會計相關</span>
                <input
                    className="form-control form-control-sm"
                    name="master_acct_courses"
                    value={consultData.master_acct_courses}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-9 col-12">
                <div className="input-group input-group-sm mt-1">
                <span className="input-group-text">碩士-商業相關</span>
                <input
                    className="form-control form-control-sm"
                    name="master_biz_courses"
                    value={consultData.master_biz_courses}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-3 col-md-4 col-6">
                <div className="input-group input-group-sm mt-1">
                <span className="input-group-text">研究所總學分</span>
                <input
                    className="form-control form-control-sm"
                    name="master_total_credits"
                    value={consultData.master_total_credits}
                    onChange={handleConsultChange}
                />
                </div>
            </div>

            {/* 報考別 */}
            <div className="col-xl-6 col-md-8 col-12">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">可報考別</span>
                <input
                    className="form-control form-control-sm"
                    name="eligible_types"
                    value={consultData.eligible_types}
                    onChange={handleConsultChange}
                />
                </div>
            </div>

            {/* 評估/初談 */}
            <div className="col-xl-3 col-md-4 col-6">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">評估者</span>
                <input
                    className="form-control form-control-sm"
                    name="evaluator_name"
                    value={consultData.evaluator_name}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-3 col-md-4 col-6">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">評估日期</span>
                <input
                    type="date"
                    className="form-control form-control-sm"
                    name="evaluated_at"
                    value={consultData.evaluated_at || ''}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-3 col-md-4 col-6">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">初談者</span>
                <input
                    className="form-control form-control-sm"
                    name="interviewer_name"
                    value={consultData.interviewer_name}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-3 col-md-4 col-6">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">初談日期/方式</span>
                <input
                    className="form-control form-control-sm"
                    name="interview_date"
                    value={consultData.interview_date}
                    onChange={handleConsultChange}
                />
                </div>
            </div>

            {/* 備註 */}
            <div className="col-xl-6 col-12">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">評估備註</span>
                <textarea
                    className="form-control form-control-sm"
                    rows={4}
                    name="evaluation_note"
                    value={consultData.evaluation_note}
                    onChange={handleConsultChange}
                />
                </div>
            </div>
            <div className="col-xl-6 col-12">
                <div className="input-group input-group-sm mt-2">
                <span className="input-group-text">初談備註/其它</span>
                <textarea
                    className="form-control form-control-sm"
                    rows={4}
                    name="consult_note"
                    value={consultData.consult_note}
                    onChange={handleConsultChange}
                />
                </div>
            </div>

            <div className="col-12 text-end">
                <button className="btn btn-sm btn-primary mt-2" onClick={handleConsultSave}>
                儲存諮詢資料
                </button>
            </div>
            </div>
        </div>
        </>
    );
}
export default AdmMemberEdit;

function MemoCell({ memoKey, value, edits, setEdits, onSave }) {
  const [editing, setEditing] = useState(false);
  const memoValue = edits[memoKey] ?? (value || "");
  const displayText = (value || "").trim() ? value : "—";

  const startEdit = () => {
    setEdits(prev =>
      prev[memoKey] === undefined ? { ...prev, [memoKey]: value || "" } : prev
    );
    setEditing(true);
  };

  const cancelEdit = () => {
    setEdits(prev => {
      const next = { ...prev };
      delete next[memoKey];
      return next;
    });
    setEditing(false);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setEdits(prev => ({ ...prev, [memoKey]: val }));
  };

  const handleSave = async () => {
    const trimmed = (memoValue ?? '').trim();
    await onSave(trimmed);   // 這裡把內容丟回父層，由父層決定打哪一支 API
    setEditing(false);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      handleSave();
    } else if (e.key === "Escape") {
      e.preventDefault();
      cancelEdit();
    }
  };

  if (!editing) {
    return (
      <div
        className="memo-view text-break"
        role="button"
        title="點擊編輯備註"
        onClick={startEdit}
        style={{ minHeight: 32, padding: "6px 8px", cursor: "text", whiteSpace: "pre-wrap" }}
      >
        {displayText}
      </div>
    );
  }

  return (
    <div className="input-group input-group-sm">
      <textarea
        className="form-control"
        rows={3}
        value={memoValue}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        autoFocus
        placeholder="輸入備註…"
        style={{ whiteSpace: "pre-wrap" }}
      />
      <span className="input-group-btn" style={{ display: "flex", gap: 6 }}>
        <button className="btn btn-primary btn-sm" type="button" onClick={handleSave}>
          儲存
        </button>
        <button className="btn btn-default btn-sm" type="button" onClick={cancelEdit}>
          取消
        </button>
      </span>
    </div>
  );
}
